import * as React from 'react';
import { Link } from 'react-router';
import styled, { css, keyframes } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexColCenter,
  FlexBetween,
  FlexRowCenter,
  FlexCol,
} from '../../Defaults/Flexbox/Flexbox';
import { ProductPriceCart } from './ProductPriceCart';
import { TagType, DsiTag as Tag } from './Tag';
import { FreeDelivery } from '../../Zemplin/Product/FreeDelivery';
import { StockInfo } from './StockInfo';
import { FavoriteCompare } from './FavoriteCompare';
import { Picture } from '../Picture/Picture';
import { DsiSvgIcon, IconType } from '../General/SvgIcon';
import { getImagePath } from '../../../utilities/product';
import { __ } from 'react-i18n';
import { DsiTags as Tags } from '../General/Tags';
import { round } from '../../../utilities';
import { ProductTabGiftCardLabel } from './ProductTabGiftCardLabel';
import { ProductTabGiftLabel } from './ProductTabGiftLabel';

export interface Props {
  id: string;
  apiUrl: string;
  addToRequest?: any;
  addToCart: any;
  picture: string;
  pictureWebP: string;
  price: string;
  oldPrice: string;
  availid: number;
  availability: string;
  name: string;
  description?: any;
  url: string;
  isNew: number;
  isSale: number | boolean;
  isFavorite: boolean;
  isCompare?: boolean;
  isSecondHand?: boolean;
  salePercentage: string;
  addToFavorite?: any;
  addToCompare?: any;
  product?: any;
  hasFavourite?: boolean;
  currency: string;
  canOrder?: boolean;
  forbiddenOrder?: boolean;
  variants?: any[];
  loadingPrices?: boolean;
  hasUser?: boolean;
  stockCount?: number;
  isFreeDelivery?: boolean;
  height?: string;
  cannotOrderButtonText?: string;
  showMoc?: boolean;
  imagePath?: string;
  hasGift?: boolean;
  hasCartSale?: boolean;
  conditionTextMapping?: any;
  condition?: any;
  isWaiting?: boolean;
  managerLink?: string;
  hiddenSale?: boolean;
  showCompareIcon?: boolean;
  boxShadow?: string;
  showCloseIcon?: boolean;
  onClose?: (productId: number) => void;
  displayType?: string;
}

function ProductTabDefault({
  id,
  addToCart,
  addToRequest,
  price,
  oldPrice,
  picture,
  pictureWebP,
  availid,
  availability,
  name,
  description,
  url,
  isNew,
  isSale,
  isFavorite,
  isCompare,
  isSecondHand,
  salePercentage,
  addToFavorite,
  addToCompare,
  product,
  currency,
  hasFavourite = false,
  canOrder,
  forbiddenOrder,
  variants,
  loadingPrices,
  hasUser,
  stockCount,
  isFreeDelivery,
  height,
  cannotOrderButtonText,
  showMoc = true,
  imagePath,
  hasGift,
  hasCartSale,
  conditionTextMapping,
  condition,
  isWaiting,
  managerLink,
  hiddenSale,
  showCompareIcon,
  boxShadow,
  showCloseIcon,
  onClose,
  displayType
}: Props) {
  const [isShowingMoreVariants, setIsShowingMoreVariants] = React.useState(
    false,
  );

  const showMoreVariants = () => {
    setIsShowingMoreVariants(true);
  };

  return (
    <Wrapper noHeightSet={isShowingMoreVariants} height={height} boxShadow={boxShadow} displayType={displayType}>
      <Tags
        isFreeDelivery={isFreeDelivery}
        isNew={isNew}
        isSale={
          hasCartSale
            ? true
            : showMoc
            ? round(+oldPrice, 2) > round(+price, 2)
            : false
        }
        isSecondHand={isSecondHand}
        isVertical={true}
        tagWidth={40}
        tagHeight={40}
        hasGift={hasGift}
        hiddenSale={hiddenSale}
      />

      <FavoriteCompareWrapper>
        <FavoriteCompare
          id={id}
          isFavorite={isFavorite}
          isCompare={isCompare}
          addToFavorite={addToFavorite}
          addToCompare={addToCompare}
          hasFavourite={hasFavourite}
          showCompareIcon={showCompareIcon}
          showCloseIcon={showCloseIcon}
          onClose={onClose}
        />

      </FavoriteCompareWrapper>
     
      <UpperWrapper>
        <ImageWrapper displayType={displayType}>
          <ImageLink to={url}>
            <picture>
              <source
                type="image/webp"
                srcSet={`${pictureWebP}`}
                // $style={customStyles}
              />
              <Image
                loading="lazy"
                alt={`${__('Obrázok ku produktu')} ${name}`}
                src={picture}
              />
            </picture>

            {/* <picture>
              <source
                type="image/webp"
                srcSet={`${pictureWebP}`}
                // $style={customStyles}
              />
              <Image
                loading="lazy"
                alt={`${__('Obrázok ku produktu')} ${name}`}
                src={picture}
              />
            </picture> */}

            {/* <Image alt={`${__('Obrázok ku produktu')} ${name}`} src={picture} /> */}
          </ImageLink>
          {variants && variants.length > 0 ? (
            isShowingMoreVariants ? (
              <VariantsWrapper>
                {variants.map(variant => (
                  <Picture
                    key={variant.good_id}
                    // srcNoWebP={getImagePath(`product/${variant.picture}`, {
                    //   width: 56,
                    //   height: 56,
                    // })}
                    // srcWebP={getImagePath(
                    //   `product/${variant.picture}`,
                    //   { width: 56, height: 56 },
                    //   false,
                    //   true,
                    // )}
                    image={`product/${variant.picture}`}
                    alt={`${__('Variant produktu')} ${variant.product_name}`}
                    customStyles={variantImage}
                    width={48}
                    height={48}
                  />
                ))}
              </VariantsWrapper>
            ) : (
              <VariantsWrapper>
                <Picture
                  key={1}
                  image={`${imagePath}`}
                  alt={`${__('Variant produktu')} ${name}`}
                  customStyles={firstVariantImage}
                  width={48}
                  height={48}
                />
                {variants.slice(0, 1).map(variant => (
                  <Picture
                    key={variant.good_id}
                    // srcNoWebP={getImagePath(`product/${variant.picture}`, {
                    //   width: 56,
                    //   height: 56,
                    // })}
                    // srcWebP={getImagePath(
                    //   `product/${variant.picture}`,
                    //   { width: 56, height: 56 },
                    //   false,
                    //   true,
                    // )}
                    image={`product/${variant.picture}`}
                    alt={`${__('Variant produktu')} ${variant.product_name}`}
                    customStyles={variantImage}
                    width={48}
                    height={48}
                  />
                ))}
                {variants.length === 2 ? (
                  <Picture
                    key={variants[1].good_id}
                    // srcNoWebP={getImagePath(`product/${variant.picture}`, {
                    //   width: 56,
                    //   height: 56,
                    // })}
                    // srcWebP={getImagePath(
                    //   `product/${variant.picture}`,
                    //   { width: 56, height: 56 },
                    //   false,
                    //   true,
                    // )}
                    image={`product/${variants[1].picture}`}
                    alt={`${__('Variant produktu')} ${
                      variants[1].product_name
                    }`}
                    customStyles={variantImage}
                    width={36}
                    height={48}
                  />
                ) : variants.length > 2 ? (
                  <VariantsNumber
                    title={__('Zobraziť viac variantov')}
                    onClick={showMoreVariants}
                  >{`+${variants.length - 2}`}</VariantsNumber>
                ) : null}
              </VariantsWrapper>
            )
          ) : null}
        </ImageWrapper>
        <NameWrapper draggable="false" to={url} displayType={displayType}>
          <StyledLink to={url}>
            <Name>{`${name}`}</Name>
          </StyledLink>
          {description ? (
            <StyledLink to={url}>
              <Description>
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </Description>
            </StyledLink>
          ) : 
            displayType !== 'small'?  <StyledLink to={url}>
                                        <Description />
                                      </StyledLink> 
                                   : <></> 
        }
        </NameWrapper>

      </UpperWrapper>
      <BottomWrapper>
        {displayType !== 'small'   
         ? <LabelsWrapper>
              {product?.product_detail?.available_gift_cards?.length ? (
                <ProductTabGiftCardLabel
                  price={price}
                  currency={currency}
                  product={product}
                />
              ) : (
                <></>
              )}

              {(hasGift && product?.product_detail?.current_sales?.[0]?.products_sale?.length === 1)?
                  <ProductTabGiftLabel product={product.product_detail.current_sales[0].products_sale[0]} />
                :<></>
              }
            </LabelsWrapper>
        : <></>
        }

        <CartWrapper>
          <StyledProductPriceCart
            price={price}
            oldPrice={showMoc ? oldPrice : '0'}
            salePercentage={salePercentage}
            isSale={isSale}
            avail_id={availid}
            addToRequest={addToRequest}
            addToCart={addToCart}
            product={product}
            currency={currency}
            canOrder={canOrder}
            forbiddenOrder={forbiddenOrder}
            loadingPrices={loadingPrices}
            hasUser={hasUser}
            cannotOrderButtonText={cannotOrderButtonText}
            isNew={!!isNew}
            isWaiting={!!isWaiting}
            hiddenSale={hiddenSale}
            displayType={displayType}
          />
          {canOrder && (
            <StockInfo
              avail_id={availid}
              availability={availability}
              onStockCount={stockCount}
              isNew={!!isNew}
              isWaiting={!!isWaiting}
              conditionTextMapping={conditionTextMapping}
              condition={condition}
            />
          )}
        </CartWrapper>
        {managerLink && (
          <a href={`${managerLink}`} target="_blank">
            Report
          </a>
        )}

        


      </BottomWrapper>
    </Wrapper>
  );
}

export const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ImageWrapper = styled.div<{displayType?: string}>`
  display: flex;
  height: ${({ displayType }) => displayType === 'small'?rem(155):rem(230)};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled(FlexColCenter)<{
  noHeightSet?: boolean;
  height?: string;
  boxShadow?: string;
  displayType?: string;
}>`
  animation: ${animateIn} 0.3s ease;
  width: 100%;
  /* max-width: ${rem(252)}; */
  margin:  ${({ displayType }) => displayType === 'small'?0:`0 ${rem(16)} ${rem(16)} 0`};
  padding: ${({ displayType }) => displayType === 'small'?`${rem(8)} ${rem(16)} ${rem(8)} ${rem(16)}`:rem(16)};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${props => (props.boxShadow ? props.boxShadow : '0px 1px 4px #00000014')};  0px 1px 4px #00000014;
  border-radius: ${rem(4)};
  position: relative;
  justify-content: space-between;
  max-width: ${rem(448)};
  height: ${props => (props.height ? props.height : '100%')};

  &:hover {
    height: ${({ noHeightSet }) =>
      noHeightSet
        ? props => (props.height ? props.height : '100%')
        : props => (props.height ? props.height : '100%')};
  }
  `;

const OldWrapper = styled(FlexColCenter)`
  animation: ${animateIn} 0.3s ease;
  width: 100%;
  max-width: ${rem(252)};
  margin: 0 ${rem(16)} ${rem(16)} 0;
  padding: ${rem(16)};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px #00000014;
  border-radius: ${rem(4)};
  position: relative;
  justify-content: space-between;

  &:nth-child(4n) {
    margin-right: 0;

    ${({ theme }) => theme.mediab.l1300`
      margin-right: ${rem(16)};
    `}

    ${({ theme }) => theme.mediab.m810`
      margin-right: 0;
      padding-right:  ${rem(8)};
    `}
  }

  &:first-child,
  &:nth-child(2),
  &:first-child > :first-child,
  &:nth-child(2) > :first-child,
  &:nth-child(3) > :first-child,
  &:nth-child(3n) > :nth-child(2) {
    border: 0;
  }
  
  ${({ theme }) => theme.mediab.l1448`
    max-width: 31.8%;

    &:nth-child(4n) {
      margin-right: ${rem(16)};
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  `}

  ${({ theme }) => theme.mediab.l1148`
    max-width: 48%;
    
    &:nth-child(3n) {
      margin-right: ${rem(16)};
    }
    
    &:nth-child(2n) {
      margin-right: 0;
    }

    &:nth-of-type(3) > :first-child {
      // border-top: ${theme.borders.primary};
    }

    &:nth-child(3n) > :nth-child(2) {
      // border-right: ${theme.borders.primary};
    }

    &:first-child &,
    &:nth-child(2) > :first-child,
    &:nth-child(2n) > :nth-child(2) {
      // border: 0;
    }
  `}

  ${({ theme }) => theme.mediab.s448`
    width: 100%;
    max-width: initial;
    min-width: initial;
    margin-right: 0;
    padding-bottom: ${rem(32)};

    & > :nth-child(2)  {
      // border: 0;
    }

    &:nth-child(2n),
    &:nth-child(3n) {
      margin-right: 0;
    }

    &:first-child &,
    &:nth-child(2) > :first-child,
    &:nth-child(2n) > :nth-child(2) {
      // border-right: 0;
      // border-top: ${theme.borders.primary};
    }

    &:first-child > :nth-child(2), &:nth-child(3n) > :nth-child(2) {
      // border-right: 0;
    }

    &:last-child {
      // border-bottom: ${theme.borders.primary};
    }
  `}
`;

const StyledProductPriceCart = styled(ProductPriceCart)`
  margin-bottom: ${rem(16)};
`;

const sharedImage = css`
  margin: ${rem(32)} 0;
  position: relative;
  width: ${rem(144)};
  height: ${rem(144)};
  min-width: ${rem(144)};
  min-height: ${rem(144)};
  transition: height 0.2s ease-in-out;

  /* &:hover {
    transform: scale(0.9);
  } */

  ${Wrapper}:hover & {
    /* transform: scale(0.5); */
    min-height: initial;
    min-width: initial;
    width: auto;
    height: ${rem(96)};
  }

  ${({ theme }) => theme.mediab.m810`
      min-width: initial;
      min-height: initial;
  `}

`;

const variantImage = css`
  margin-right: ${rem(8)};
  padding: ${rem(4)};
  position: relative;
  width: ${rem(56)};
  height: ${rem(56)};
  transition: transform 0.2s;
  border: ${({ theme }) => theme.borders.banners};
  border-radius: ${rem(4)};
`;

const firstVariantImage = css`
  margin-right: ${rem(8)};
  padding: ${rem(4)};
  position: relative;
  width: ${rem(56)};
  height: ${rem(56)};
  transition: transform 0.2s;
  border: ${({ theme }) => `1px solid ${theme.colors.successColor}`};
  border-radius: ${rem(4)};
`;

const VariantsWrapper = styled(FlexRowCenter)`
  display: none;
  margin-bottom: ${rem(16)};
  flex-wrap: wrap;

  ${Wrapper}:hover & {
    display: flex;
  }
`;

const VariantsNumber = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${rem(56)};
  height: ${rem(56)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(16)};
  border: ${({ theme }) => theme.borders.banners};
  background: white;
  cursor: pointer;
`;

const Image = styled.img`
  ${sharedImage}
`;

const ImageLink = styled(Link)``;

const UpperWrapper = styled(FlexColCenter)`
  width: 100%;
`;

const BottomWrapper = styled(FlexColCenter)`
  width: 100%;
  justify-content: space-between;
`;

const CartWrapper = styled(FlexCol)`
  width: 100%;
`;

const NameWrapper = styled(Link)<{displayType?:string}>`
  text-decoration: none;
  width: 100%;
  margin-bottom: ${({ displayType }) => displayType === 'small'?rem(4):rem(24)};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
`;

const Name = styled(TextP)`
  /* height: ${rem(38)}; */
  font-size: ${rem(16)};
  line-height: ${rem(19)};
  margin-bottom: ${rem(8)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: center;
  width: 100%;
  font-weight: 480;
  transition: color 0.2s;
  cursor: pointer;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(8)};
  `}
`;

const Description = styled(TextP)`
  /* height: ${rem(80)}; */
  text-align: left;
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  font-size: ${rem(14)};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  cursor: pointer;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;
  max-height: ${rem(60)};
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  ${({ theme }) => theme.mediab.m580`
      height: initial;
  `}
`;

const TagsWrapper = styled(FlexBetween)`
  z-index: 1;
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
  flex-direction: column;

  ${({ theme }) => theme.mediab.m810`
  `}
`;

const FavoriteCompareWrapper = styled.div`
  position: absolute;
  top: ${rem(16)};
  right: ${rem(16)};
  z-index: 1;
`;

const LabelsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(10)};
  width: 100%;
  margin-bottom: ${rem(15)};
`


export { ProductTabDefault as DsiProductTabDefault };
